//	------------------------------------------------------------------
//	Recent searches, persisted in localStorage. Newest first, unique
//	(case-insensitive), capped at MAX. Only submitted searches are saved.
//	------------------------------------------------------------------
const KEY = 'bb_recent_searches';
const MAX = 8;

const canUseStorage = () => typeof window !== 'undefined' && !!window.localStorage;

export const getRecentSearches = () => {
	if (!canUseStorage()) return [];
	try {
		const stored = JSON.parse(window.localStorage.getItem(KEY));
		return Array.isArray(stored) ? stored : [];
	} catch (e) {
		return [];
	}
};

export const addRecentSearch = term => {
	const clean = (term || '').trim();
	if (!clean || !canUseStorage()) return getRecentSearches();
	try {
		const existing = getRecentSearches().filter(t => t.toLowerCase() !== clean.toLowerCase());
		const next = [clean, ...existing].slice(0, MAX);
		window.localStorage.setItem(KEY, JSON.stringify(next));
		return next;
	} catch (e) {
		return getRecentSearches();
	}
};

export const clearRecentSearches = () => {
	if (!canUseStorage()) return;
	try {
		window.localStorage.removeItem(KEY);
	} catch (e) { /* ignore */ }
};
